// Kleine fachliche Helfer, die mehr als eine Seite braucht - keine Formatierung (format.ts), keine Pfade (pfade.ts).

import type { Artikel } from './typen'

/**
 * Aufeinanderfolgende Einträge mit demselben Titel zu einem Block zusammenfassen - die Kopfzeile der
 * Kladde (je Fertigartikel) und der Disposition (je Block) entstehen so.
 */
export function bloecke<T>(liste: T[], titel: (eintrag: T) => string): { titel: string; breite: number }[] {
  const ergebnis: { titel: string; breite: number }[] = []
  for (const eintrag of liste) {
    const name = titel(eintrag)
    const letzter = ergebnis[ergebnis.length - 1]
    if (letzter && letzter.titel === name) letzter.breite += 1
    else ergebnis.push({ titel: name, breite: 1 })
  }
  return ergebnis
}

/**
 * Aus dem Gebindegewicht folgt die MVN: 1.000 kg geteilt durch das Gewicht. Ein leeres oder
 * unbrauchbares Gewicht löscht nur das Gewicht, die MVN bleibt, wie sie ist.
 */
export function mvnAusGewicht(kg: number | null): { gebindegewicht_kg: number | null; mvn?: number; mvn_begruendung?: string } {
  if (kg === null || !Number.isFinite(kg) || kg <= 0) return { gebindegewicht_kg: null }
  return {
    gebindegewicht_kg: kg,
    mvn: Math.round((1000 / kg) * 10000) / 10000,
    mvn_begruendung: `${kg} kg je Gebinde, im Dashboard eingetragen`,
  }
}

/** Ein aktives Material ohne Umrechnung - das fällt in jeder Liste auf, weil es nicht in Tonnen gerechnet werden kann. */
export function ohneMvn(a: Pick<Artikel, 'art' | 'aktiv' | 'mvn'>): boolean {
  return a.art === 'material' && a.aktiv && !a.mvn
}

/** Die Fertigartikel, die in der Kladde geführt werden. */
export function aktiveFertigartikel<T extends Pick<Artikel, 'art' | 'aktiv'>>(liste: T[]): T[] {
  return liste.filter((a) => a.art === 'fertigartikel' && a.aktiv)
}
